import { Page } from '@components/layout'

export const AgendaView = () => {
  return (
    <Page
      title="Agenda"
      description="Agenda"
    >
      <p style={{color: "#0075A9", "font-weight": "bold", "font-size": "1.5rem"}}>Agenda coming soon.</p>
    </Page>
  )
}